import { QuizzesResponse } from '../types';
import { concatQuizAndFolders } from './concatQuizAndFolders';
import { QuizItemCache, toQuizItemCache } from './toQuizItemCache';
import { toQuizOrFolder } from './toQuizOrFolder';

export const normalizeQuizzesResponse = (quizResponse: QuizzesResponse) => {
  return concatQuizAndFolders(quizResponse)
    .map(toQuizOrFolder)
    .reduce(toQuizItemCache, {
      itemById: {},
      itemIdByType: { folder: [], quiz: [] },
      rootItems: [],
    } as QuizItemCache);
};
